// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2ie1e","label":"Radio_label__2-eTl","checkMark":"Radio_checkMark__2uTZ-","disabled":"Radio_disabled__gr1PW"};